import { render } from "./CreditCardIcon.vue?vue&type=template&id=395101f2&scoped=true"
import script from "./CreditCardIcon.vue?vue&type=script&lang=js"
export * from "./CreditCardIcon.vue?vue&type=script&lang=js"

import "./CreditCardIcon.vue?vue&type=style&index=0&id=395101f2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-395101f2"

export default script